export const environment = {
  apiUrl: 'https://valabxq1o3.execute-api.us-west-2.amazonaws.com/gfx-core-production/api/v1',
  newApiUrl: 'http://localhost:4001',
  editorUrl: 'https://editor.gfx.tech',
  production: false,
  env: 'production',
};
